module.exports = __webpack_public_path__ + "img/sample1.f192de22.jpeg";